import axiosHttpRequest from "../axios";

async function getPrevJobId(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execGetRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  let serviceData = serviceResponse.data;
  let listViewData = [];
  let listViewInfo = {};
  if (serviceData.issuccess && serviceData.Records) {
    listViewData = serviceData.Records;
  }
  listViewInfo.records = listViewData;
  return listViewData;
}

export default {
  getPrevJobId,
};
